// extracted by css-extract-rspack-plugin
export default {"courses-list":"ixQB_LZ___courses-list","coursesList":"ixQB_LZ___courses-list"};